<template>
  <main class="main" role="main">
    <div class="main_con">
      <div class="notice_list">
        <ul class="notice_list_ul">
          <li class="notice_list_li">
            <div class="notice_list_ttl">{{ article.title }}</div>
            <div class="notice_list_date">{{ article.createdAt }}</div>
          </li>
        </ul>
      </div>
      <div class="notice_detail">
        <div class="editor">
          <div v-html="article.content"></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapState, mapGetters } from '@common/store/modules/board';
import * as types from '@common/store/modules/board/types';
export default {
  data() {
    return {};
  },
  async created() {
    await this.fetchArticle(this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      article: types.ARTICLE,
    }),
  },
  methods: {
    ...mapActions([types.FETCH_ARTICLE]),
    async fetchArticle(id) {
      const param = {
        id: id,
      };
      if (param.id) {
        await this[types.FETCH_ARTICLE](param);
      }
    },
  },
};
</script>
